// #110: a public multi-dish visit fans out to ONE review row per rated dish —
// that per-dish signal powers dish ranking (#102 rung-3 best-places), so the
// rows are kept. For DISPLAY, regroup those rows by visit so a visit reads as a
// single entry (each dish shown with its own rating + photos inside). Reviews
// not tied to a visit (visit_id null) stay standalone. Order is preserved by
// first appearance. Shared by the restaurant Reviews list and the profile's
// "My Reviews" tab so both collapse identically.

export function groupReviewsByVisit(list) {
  const groups = [];
  const byVisit = new Map();
  for (const r of (list || [])) {
    if (r.visit_id == null) { groups.push([r]); continue; }
    if (byVisit.has(r.visit_id)) { groups[byVisit.get(r.visit_id)].push(r); }
    else { byVisit.set(r.visit_id, groups.length); groups.push([r]); }
  }
  return groups;
}

// Best display name for the dish a review is about (#110): the snapshotted
// off-menu/custom name (#119) wins, else the menu item's custom name, else its
// catalog food's name, else a plain food review's name.
export function reviewDishName(review) {
  if (review.dish_name && review.dish_name.trim()) return review.dish_name.trim();
  if (review.menu_item) {
    const cn = (review.menu_item.custom_name || '').trim();
    return cn || review.menu_item.food?.name || 'Dish';
  }
  if (review.food) return review.food.name;
  return null;
}
